import TextField from '@mui/material/TextField';
import styled from "styled-components";

let Container=styled.div`
 	display:flex;
	align-items:center;
	justify-content:space-between;
	width:10vw;
	margin:15px
`

export default function InputFlagReventa(props){
	let {codflag,precio,label}=props;

	return(
		<Container>
 			<img loading="lazy" width="20" alt="flag"
            	srcSet={`https://flagcdn.com/w40/${codflag}.png 2x`} 
               	src={`https://flagcdn.com/w20/${codflag}.png`} 
            />
 			<TextField  size="small" sx={{width:"7vw",minWidth:"60px"}}  label={label} value={precio} />
 		</Container>


		)

}